module.exports = __webpack_public_path__ + "img/legalServices-6.f6aed4d7.png";